import { useState } from 'react';
import { faqs } from '@/mocks/site';

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="py-24 md:py-32 bg-warm">
      <div className="max-w-container mx-auto px-5 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-cocoa">FAQ</div>
            <h2 className="mt-3 font-display font-bold text-[44px] md:text-[54px] leading-[1.02] text-cocoa">
              Answers, before you book.
            </h2>
          </div>
          <div className="lg:col-span-8 space-y-4">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`rounded-[28px] border transition-colors duration-300 ${isOpen ? 'bg-white border-cocoa/25' : 'bg-white border-line hover:border-cocoa/20'}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="w-full flex items-start justify-between gap-6 text-left cursor-pointer px-7 md:px-8 py-6 md:py-7"
                    aria-expanded={isOpen}
                  >
                    <span className="font-display font-semibold text-[19px] md:text-[22px] text-cocoa">{f.q}</span>
                    <span className={`faq-icon w-10 h-10 flex items-center justify-center rounded-full shrink-0 ${isOpen ? 'is-open bg-cocoa text-white' : 'bg-warm text-cocoa'}`}>
                      <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-[20px]`}></i>
                    </span>
                  </button>
                  <div className={`faq-panel ${isOpen ? 'is-open' : ''}`}>
                    <div className="faq-panel-inner">
                      <div className="px-7 md:px-8 pb-7 -mt-1 text-[16px] text-ink/80 leading-relaxed max-w-[640px]">
                        {f.a}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}